import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useParams } from "react-router";

import TypesManagement from "../../components/MenuSetting/TypesManagement";
import TypesCatsManagement from "../../components/MenuSetting/TypesCatsManagement";
import { Tab, Tabs } from "react-bootstrap";


const MenuSetting = () => {

    const params = useParams();

    return (
        params.typeid ?
        <MenuManagement>
            <TypesCatsManagement type_id={params.typeid} /> 
            {/* <span>This feature is not available</span> */}
        </MenuManagement>
        :
        <MenuManagement>
            <Tittle>Menu Setting</Tittle>
            <Tabs>
                <Tab eventKey={0} title='Normal'>
                    <ComponentContainer>
                        <TypesManagement/>  
                        {/* <span>This feature is not available</span> */}
                    </ComponentContainer>
                </Tab>
                <Tab eventKey={1} title='Express'>
                    <ComponentContainer>
                     <span>This feature is not available</span>
                    </ComponentContainer>
                </Tab>
            </Tabs>
                     
        </MenuManagement>
    )
}

const MenuManagement = styled.div`
    margin: 30px 15px;
    padding: 30px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

    nav {
        border-bottom: 1px solid #dee2e6 !important;
        justify-content: center;
    }

    .nav.nav-tabs .nav-item.nav-link.active {
        color: #007bff;
    }
    .nav.nav-tabs .nav-item.nav-link{
        color: #495057;

    }
`

const ComponentContainer =styled.div`
    padding: 20px;
    border: 1px solid #dee2e6;
    border-top: none;
`;

 const Tittle = styled.h4`
    margin-bottom: 10px;
`

export default MenuSetting;